import store from '../store';

export default {
  requestInterceptor(config) {
    const token = `Bearer ${store.state.app.auth_token}`;
    config.headers.Authorization = token;

    return config;
  },
  responseErrorInterceptor(error) {
    console.log(error);
    if (error.response.status === 401) {
      window.location.href = error.response.data.oauth_url;
    }
    return error;
  },
};



// WEBPACK FOOTER //
// ./src/services/auth.js